<template>
  <div class="news_hot_content">
    <p class="news_tips">
      <!-- <span>热点新闻</span> -->
       <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="热点新闻" name="first"></el-tab-pane>
          <el-tab-pane label="政策法规" name="second"></el-tab-pane>
          <el-tab-pane label="展会活动" name="third"></el-tab-pane>
          <el-tab-pane label="项目信息" name="fourth"></el-tab-pane>
        </el-tabs>
      <!-- <span class="span" v-if="title" @click="sendData">换一批</span>
      <span v-else>更多></span> -->
    </p>
    <ul>
      <li
        @click="goToDetail(item)"
        @mouseenter="sendImgUrl(item)"
        v-for="(item, index) in list"
        :key="index"
      >
        <p v-if="index === 0" class="news_title_first">{{ item.title }}</p>
        <p v-else class="news_title">{{ item.title }}</p>
        <!-- <p class="news_title">{{ item.title }}</p>
        <p class="news_desc">
          {{ item.description }}
        </p> -->
      </li>
    </ul>
  </div>
</template>

<script>
import {
  getIndustryinfoList,
  getActivityList,
} from "../api/information";
export default {
  props: {
    title: {
      type: String,
    },
    list: {
      type: Array,
    },
    limit: {
      type: Number,
      default: 14
    }
  },
  data(){
    return {
      activeName:'first',
      allList:[],
      tabIndex: 0,
    }
  },
  methods: {
    handleClick(tab,event){
        console.log("点击标签")
        console.log(tab.index)
        this.tabIndex = tab.index
        this.list = []
        if (tab.index == 0){
          this.getHotIndustryinfoList()
        }else if(tab.index == 1){
          this.getHotIndustryinfoList(47)
        }else if(tab.index == 2){
          this.getActivityList()
        }else if(tab.index == 3){
          this.getHotIndustryinfoList(15)
        }
    },
    // 获取资讯
     getHotIndustryinfoList(type) {
      getIndustryinfoList({
        hot: 1,
        curPage: 1,
        limit: this.limit,
        type: type
      }).then((res) => {
        console.log(res)
        if(res.code == 0){
          this.list = res.page.list;
          // this.getRandomList(12);
        }
        // location.reload()
      })
        .catch((err) => {});
    },

    //获取展会列表
    getActivityList() {
      getActivityList({
        curPage: 1,
        limit: this.limit,
        recommend: 1,
        type:1,
      }).then((res) => {
        if(res.code == 0){
          this.list = res.page.list;
        }
      });
    },
    sendData() {
      this.$emit("dataRefresh");
    },
    sendImgUrl(item) {
      this.$emit("sendImgUrl", item);
    },
    goToDetail(item) {
      if (this.tabIndex == 2){
        let routeUrl = this.$router.resolve({
          path:'/exhibition_detail',
          query:{id:item.id}
        });
        window.open(routeUrl.href,'_blank')
      }else{
        let routeUrl = this.$router.resolve({
          path:'/info_detail',
          query:{id:item.id}
        });
        window.open(routeUrl.href,'_blank')
      }
    },
  }
};
</script>

<style scoped lang="less">
.news_hot_content {
  width: 100%;
  .news_tips {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    // span {
    //   &:nth-of-type(1) {
    //     position: relative;
    //     font-size: 24px;
    //     font-family: Microsoft YaHei;
    //     font-weight: bold;
    //     color: #333333;
    //     padding-left: 15px;
    //     &::before {
    //       display: inline-block;
    //       content: "";
    //       width: 5px;
    //       height: 24px;
    //       background: #ff7302;
    //       position: absolute;
    //       left: 0;
    //       top: 5px;
    //     }
    //   }
    //   &:nth-of-type(2) {
    //     font-size: 14px;
    //     font-family: Microsoft YaHei;
    //     font-weight: 400;
    //     color: #999999;
    //   }
    // }

    .span {
      cursor: pointer;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      &::before {
        display: inline-block;
        content: "";
        width: 17px;
        height: 17px;
        background: url("../assets/images/break.png") no-repeat center/100%;
        vertical-align: top;
        margin-right: 5px;
        margin-top: 3px;
      }
    }
  }
  ul {
    li {
      cursor: pointer;
      margin: 10px 0;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 10px;
      &:last-of-type {
        border-bottom: 0;
      }
      &:hover {
        .news_title{
          color: #ff8a02;

        }
        .news_desc{
          color: #ff8a02;
        }
      }
      .news_title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        // 单行溢出省略
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .news_title_first {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        // 单行溢出省略
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
      }
      .news_desc {
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        // 多行溢出省略
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin-top: 1px;
        max-height: 48px;
        height: 48px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/hotNews.vue